export default function getTilesConfiguration() {
  const SERVICE_PROVIDER_LIST = [
    { name: "City Power", category: "Electricity", phone: "086 000 7788", icon: "bi bi-lightning-charge-fill" },
    { name: "Johannesburg Water", category: "Water & Sanitation", phone: "011 688 2500", icon: "bi bi-droplet-fill" },
    { name: "Afrox Gas", category: "Gas Supply", phone: "086 022 3300", icon: "bi bi-fire" },
    { name: "Vumatel", category: "Fibre Internet", phone: "087 820 9000", icon: "bi bi-wifi" },
    { name: "Fidelity ADT", category: "Security Response", phone: "086 013 4354", icon: "bi bi-shield-lock-fill" },
    { name: "Vuma Cam", category: "CCTV Monitoring", phone: "010 500 3000", icon: "bi bi-camera-video-fill" },
    { name: "Engen Fleet", category: "Diesel Supply", phone: "086 010 1010", icon: "bi bi-truck" }
  ];

  return [
    {
      id: 'Lesedi City Shopping Centre (Live)',
      title: 'Lesedi City Shopping Centre',
      stats: 'Energy Efficiency 85%',
      description: 'Shopping Centre',
      trend: '+2.1%',
      coordinates: { lat: -26.354546849182338, lng: 28.197169881076025 },
      propertyOverview: { size: '7,360 m²', occupancy: '92%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Vosloorus Precinct",
        stationContact: "011 861 6600",
        crimeIndex: "High",
        periodIncrease: "14% increase from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 12, trend: "-5%" },
          { category: "Theft from Vehicle", count: 8, trend: "+10%" },
          { category: "Assault", count: 4, trend: "0%" },
          { category: "Burglary", count: 3, trend: "-15%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://forum.vosloorus-community.co.za"
      },
      tileCards: [
        {
          id: "Lesedi-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Phindile Tsotetsi",
              role: "Centre Manager",
              status: "on-site",                 // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "066 136 7815",
              email: "N/A",
              address: "Mc Botha Dr, Vosloorus, Johannesburg, 1475",
              website: "N/A"
            },
            {
              full_name: "Thabo Nkosi",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "011 000 0000",
              email: "security@lesedi.co.za",
              address: "Mc Botha Dr, Vosloorus, Johannesburg, 1475",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Lesedi-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Lesedi City Shopping Centre',
          coordinates: { lat: -26.354546849182338, lng: 28.197169881076025 }
        },
        {
          id: 'Lesedi-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Ekuphumleni Retail Centre (Live)',
      title: 'Ekuphumleni Retail Centre',
      stats: 'Energy Efficiency 93%',
      description: 'Retail Centre',
      trend: '+3.1%',
      coordinates: { lat: -33.679000387909795, lng: 26.667498296251875 },
      propertyOverview: { size: '6,468 m²', occupancy: '98%', description: 'Retail Centre' },
      crimeStats: {
        precinct: "Kenton-On-Sea",
        stationContact: "046 648 1234",
        crimeIndex: "Medium",
        periodIncrease: "12% decrease from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 6, trend: "-15%" },
          { category: "Theft from Vehicle", count: 3, trend: "-20%" },
          { category: "Assault", count: 2, trend: "-10%" },
          { category: "Burglary", count: 1, trend: "-25%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://kentonsea-community.co.za"
      },
      tileCards: [
        {
          id: "Ekuphumleni-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Zimkihita",
              role: "Centre Manager",
              status: "on-site",                 // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "083 246 3531",
              email: "N/A",
              address: "1355 Kariega Rd, Kenton-on-Sea, 6191",
              website: "N/A"
            },
            {
              full_name: "Security Control Room",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "N/A",
              email: "N/A",
              address: "1355 Kariega Rd, Kenton-on-Sea, 6191",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Ekuphumleni-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Ekumphumleni Retail Centre',
          coordinates: { lat: -33.679000387909795, lng: 26.667498296251875 }
        },
        {
          id: 'Ekuphumleni-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Ganyesa (Live)',
      title: 'Ganyesa',
      stats: 'Energy Efficiency 88%',
      description: 'Shopping Centre',
      trend: '+2.8%',
      coordinates: { lat: -26.592221664133994, lng: 24.171883924024844 },
      propertyOverview: { size: '5,200 m²', occupancy: '85%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Ganyesa Precinct",
        stationContact: "053 998 2000",
        crimeIndex: "Medium",
        periodIncrease: "6% increase from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 8, trend: "+2%" },
          { category: "Theft from Vehicle", count: 5, trend: "+8%" },
          { category: "Assault", count: 3, trend: "-5%" },
          { category: "Burglary", count: 2, trend: "0%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://ganyesa-community-safety.co.za"
      },
      tileCards: [
        {
          id: "Ganyesa-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Tlhaloso",
              role: "Centre Manager",
              status: "on-site",              // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "053 998 1234",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Ganyesa, 8613",
              website: "N/A"
            },
            {
              full_name: "Security Control Room",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "N/A",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Ganyesa, 8613",
              website: "N/A"
            },
            {
              full_name: "Facilities Office",
              role: "Facilities Manager",
              status: "on-site",
              hours: "Mon-Fri 8am-5pm",
              phone: "N/A",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Ganyesa, 8613",
              website: "N/A"
            },
            {
              full_name: "After-Hours Emergency",
              role: "Emergency Contact",
              status: "off-site",
              hours: "After Hours",
              phone: "N/A",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Ganyesa, 8613",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Ganyesa-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Ganyesa Shopping Centre',
          coordinates: { lat: -26.592221664133994, lng: 24.171883924024844 }
        },
        {
          id: 'Ganyesa-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Thembokwezi Square (Live)',
      title: 'Thembokwezi Square',
      stats: 'Energy Efficiency 92%',
      description: 'Shopping Centre',
      trend: '+3.8%',
      coordinates: { lat: -34.010426263680884, lng: 18.631392278305782 },
      propertyOverview: { size: '6,468 m²', occupancy: '91%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Philippi East",
        stationContact: "021 370 1000",
        crimeIndex: "High",
        periodIncrease: "7% increase from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 14, trend: "+8%" },
          { category: "Theft from Vehicle", count: 9, trend: "+12%" },
          { category: "Assault", count: 6, trend: "+5%" },
          { category: "Burglary", count: 4, trend: "+3%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://philippi-community-watch.co.za"
      },
      tileCards: [
        {
          id: "Thembokwezi-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Mzwandile",
              role: "Centre Manager",
              status: "on-site",               // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "082 882 3507",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            },
            {
              full_name: "Security Control Room",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "N/A",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            },
            {
              full_name: "Facilities Office",
              role: "Facilities Manager",
              status: "on-site",
              hours: "Mon-Fri 8am-5pm",
              phone: "N/A",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            },
            {
              full_name: "After-Hours Emergency",
              role: "Emergency Contact",
              status: "off-site",
              hours: "After Hours",
              phone: "N/A",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Thembokwezi-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Thembokwezi Square',
          coordinates: { lat: -34.010426263680884, lng: 18.631392278305782 }
        },
        {
          id: 'Thembokwezi-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Amsterdam',
      title: 'Amsterdam',
      stats: 'Energy Efficiency 90%',
      description: 'Shopping Centre',
      trend: '+3.5%',
      coordinates: { lat: -26.62135062117394, lng: 30.66334535193961 },
      propertyOverview: { size: '4,800 m²', occupancy: '88%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Amsterdam-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Amsterdam Plaza, Amsterdam, North West',
            hours: 'Mduduzi: Mon-Fri 8am-5pm',
            website: 'N/A',
            phone: '071 081 0963',
            email: 'N/A'
          }
        },
        {
          id: 'Amsterdam-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Amsterdam Shopping Centre',
          coordinates: { lat: -26.62135062117394, lng: 30.66334535193961 }
        },
        {
          id: 'Amsterdam-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Madadeni',
      title: 'Madadeni',
      stats: 'Energy Efficiency 82%',
      description: 'Shopping Centre',
      trend: '+1.8%',
      coordinates: { lat: -27.75115777641586, lng: 30.040223764057334 },
      propertyOverview: { size: '6,200 m²', occupancy: '80%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Madadeni-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Madadeni Plaza, Madadeni, KwaZulu-Natal',
            hours: 'Percy: Mon-Fri 8am-5pm',
            website: 'www.madadeni-shopping.co.za',
            phone: '034 312 3456',
            email: 'management@madadeni.co.za'
          }
        },
        {
          id: 'Madadeni-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Madadeni Shopping Centre',
          coordinates: { lat: -27.75115777641586, lng: 30.040223764057334 }
        },
        {
          id: 'Madadeni-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Aliwal North',
      title: 'Aliwal North',
      stats: 'Energy Efficiency 89%',
      description: 'Shopping Centre',
      trend: '+3.2%',
      coordinates: { lat: -30.68776177047174, lng: 26.70567442400857 },
      propertyOverview: { size: '5,500 m²', occupancy: '87%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Aliwal North-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Aliwal North Mall, Aliwal North, Eastern Cape',
            hours: 'Monday-Friday: 8am-5pm',
            website: 'www.aliwalnorth-shopping.co.za',
            phone: '051 633 1234',
            email: 'management@aliwalnorth.co.za'
          }
        },
        {
          id: 'Aliwal North-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Aliwal North Shopping Centre',
          coordinates: { lat: -30.68776177047174, lng: 26.70567442400857 }
        },
        {
          id: 'Aliwal North-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Rustenburg',
      title: 'Rustenburg',
      stats: 'Energy Efficiency 94%',
      description: 'Shopping Centre',
      trend: '+4.2%',
      coordinates: { lat: -25.661489005216822, lng: 27.229414900860824 },
      propertyOverview: { size: '8,500 m²', occupancy: '96%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Rustenburg-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Rustenburg Mall, Rustenburg, North West',
            hours: 'Monday-Friday: 8am-5pm',
            website: 'www.rustenburg-shopping.co.za',
            phone: '014 597 1234',
            email: 'management@rustenburg.co.za'
          }
        },
        {
          id: 'Rustenburg-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Rustenburg Shopping Centre',
          coordinates: { lat: -25.661489005216822, lng: 27.229414900860824 }
        },
        {
          id: 'Rustenburg-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Ngqamakhwe',
      title: 'Ngqamakhwe',
      stats: 'Energy Efficiency 86%',
      description: 'Shopping Centre',
      trend: '+2.4%',
      coordinates: { lat: -32.20156036090335, lng: 27.937288435460438 },
      propertyOverview: { size: '4,300 m²', occupancy: '83%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Ngqamakhwe-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Ngqamakhwe Plaza, Ngqamakhwe, Eastern Cape',
            hours: 'Monday-Friday: 8am-5pm',
            website: 'www.ngqamakhwe-shopping.co.za',
            phone: '047 498 1234',
            email: 'management@ngqamakhwe.co.za'
          }
        },
        {
          id: 'Ngqamakhwe-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Ngqamakhwe Shopping Centre',
          coordinates: { lat: -32.20156036090335, lng: 27.937288435460438 }
        },
        {
          id: 'Ngqamakhwe-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Mkhondo (Piet Retief)',
      title: 'Mkhondo (Piet Retief)',
      stats: 'Energy Efficiency 91%',
      description: 'Shopping Centre',
      trend: '+3.6%',
      coordinates: { lat: -27.010240677665344, lng: 30.80566348439843 },
      propertyOverview: { size: '7,100 m²', occupancy: '90%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Mkhondo-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Mkhondo Mall, Piet Retief, Mpumalanga',
            hours: 'Sabrina Nel: Mon-Fri 8am-5pm',
            website: 'www.mkhondo-shopping.co.za',
            phone: '082 694 1884',
            email: 'management@mkhondo.co.za'
          }
        },
        {
          id: 'Mkhondo-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Mkhondo Shopping Centre',
          coordinates: { lat: -27.010240677665344, lng: 30.80566348439843 }
        },
        {
          id: 'Mkhondo-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Erica Square',
      title: 'Erica Square',
      stats: 'Energy Efficiency 97%',
      description: 'Shopping Centre',
      trend: '+4.5%',
      coordinates: { lat: -33.941725891736155, lng: 18.627625024958483 },
      propertyOverview: { size: '5,830 m²', occupancy: '95%', description: 'Shopping Centre' },
      teamContacts: [
        { initials: "SM", name: "Sarah Mbatha", role: "Centre Manager", status: "on-site" },
        { initials: "TN", name: "Thabo Nkosi", role: "Security Manager", status: "on-site" },
        { initials: "LV", name: "Linda van der Merwe", role: "Facilities Manager", status: "break" },
        { initials: "PM", name: "Peter Molefe", role: "IT Systems Manager", status: "on-site" }
      ],
      recentDocuments: [
        { title: "Q4 2025 Performance Report – Erica", updated: "2 hours ago", size: "2.4 MB", icon: "bi bi-file-earmark-pdf-fill" },
        { title: "Energy Consumption Analysis – Erica", updated: "yesterday", size: "1.8 MB", icon: "bi bi-file-earmark-excel-fill" },
        { title: "Incident Report – Nov 28 (Erica)", updated: "3 days ago", size: "856 KB", icon: "bi bi-file-earmark-word-fill" },
        { title: "Maintenance Schedule – December (Erica)", updated: "1 week ago", size: "3.2 MB", icon: "bi bi-file-earmark-pdf-fill" }
      ],
      shiftSchedule: [
        { label: "Security – Morning Shift", time: "06:00 – 14:00", personnel: 12 },
        { label: "Cleaning – Day Shift", time: "08:00 – 16:00", personnel: 18 },
        { label: "Security – Evening Shift", time: "14:00 – 22:00", personnel: 14 },
        { label: "Maintenance – Night Shift", time: "22:00 – 06:00", personnel: 8 }
      ],
      tileCards: [
        {
          id: 'Erica-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Ground Floor, 35 Ferguson Rd, Illovo, Sandton, 2196',
            hours: 'Mzwandile: Mon-Fri 9am-6pm',
            website: 'www.erica-shopping.co.za',
            phone: '082 882 3507',
            email: 'management@erica.co.za'
          }
        },
        {
          id: 'Erica-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Erica Square',
          coordinates: { lat: -33.941725891736155, lng: 18.627625024958483 }
        },
        {
          id: 'Erica-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    }
  ];
}
